import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DecorationHeadlineComponent} from './decoration-headline/decoration-headline.component';
import {SectionHeadlineComponent} from './section-headline/section-headline.component';
import {ImageTextComponent} from './image-text/image-text.component';
import {InspirationCardComponent} from './inspiration-card/inspiration-card.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [ DecorationHeadlineComponent, SectionHeadlineComponent, ImageTextComponent, InspirationCardComponent ],
    exports: [ DecorationHeadlineComponent, SectionHeadlineComponent, ImageTextComponent, InspirationCardComponent ]
})
export class DecorationModule { }
